const BECOME_A_MEMBER_PATH = '/bli-medlem';
const normalizePathname = (pathname?: string | null) => {
  if (!pathname) {
    return '';
  }

  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
};

export const isEspialDisabledPath = (pathname?: string | null) => {
  const normalizedPath = normalizePathname(pathname);

  return normalizedPath === BECOME_A_MEMBER_PATH || /^\/velkommen-som-medlem\/[^/]+$/.test(normalizedPath);
};
